import { useCallback, useEffect, useRef } from 'react'

interface PercentageChartProps {
  score: number
  color: string
}

export const PercentageChart = ({ score, color }: PercentageChartProps) => {
  const canvasRef = useRef<HTMLCanvasElement>(null)

  const draw = useCallback(() => {
    const ctx: CanvasRenderingContext2D = canvasRef.current?.getContext(
      '2d'
    ) as CanvasRenderingContext2D
    ctx.reset()
    ctx.beginPath()
    ctx.arc(280, 270, 255, radians(180), radians(360))
    ctx.lineWidth = 20
    ctx.strokeStyle = '#ECECEC'
    ctx.lineCap = 'round'
    ctx.stroke()

    const base = 180
    const percentate = (score * 180) / 100
    ctx.beginPath()
    ctx.arc(280, 270, 255, radians(180), radians(percentate + base))
    ctx.lineWidth = 20
    ctx.strokeStyle = color
    ctx.lineCap = 'round'
    ctx.stroke()

    ctx.beginPath()
    ctx.setLineDash([12, 23])
    ctx.arc(280, 273, 225, radians(180), radians(360))
    ctx.lineWidth = 8
    ctx.strokeStyle = '#ECECEC'
    ctx.lineCap = 'butt'
    ctx.stroke()
  }, [color, score])

  const radians = (degrees: number) => {
    const calc = (Math.PI / 180) * degrees
    return calc
  }

  useEffect(() => {
    draw()
  }, [score, color, draw])

  return (
    <canvas ref={canvasRef} width="560" height="284" className="h-full w-full">
      Su navegador no soporta Canvas.
    </canvas>
  )
}
